!function(g) {
    "function" != typeof Object.create && (Object.create = function(proto, propertiesObject) {
        if ("object" != typeof proto && "function" != typeof proto) throw new TypeError("Object prototype may only be an Object: " + proto);
        if (null === proto) throw new Error("This browser's implementation of Object.create is a shim and doesn't support 'null' as the first argument.");
        if (void 0 !== propertiesObject) throw new Error("This browser's implementation of Object.create is a shim and doesn't support a second argument.");
        function F() {}
        return F.prototype = proto, new F;
    });
    var createCurry = function(fn, args) {
        return args.length >= fn.length ? fn.apply(fn, args) : function() {
            return 0 == arguments.length && (arguments = [
                null
            ]), createCurry(fn, args.concat([].slice.apply(arguments)));
        };
    }, curry = function(fn) {
        return "function" != typeof fn ? null : function() {
            return 0 == arguments.length && (arguments = [
                null
            ]), createCurry(fn, [].slice.apply(arguments));
        };
    }, flow = function() {
        var args = arguments;
        return function(x) {
            for(var i = 0; i < args.length; i++)"function" == typeof args[i] && (x = args[i].call(null, x));
            return x;
        };
    }, match = curry(function(q, str) {
        return String.prototype.match.call(str, q) || [];
    }), replace = curry(function(q, r, str) {
        return String.prototype.replace.call(str, q, r);
    }), trim = replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), pad = curry(function(right, add, len, str) {
        isExist(right) || (right = !1), isExist(add) || (add = "0"), str = parseInt(str), isString(str) || (str += "");
        for(var needLen = len - str.length, needStr = ""; needStr.length < needLen;)needStr += add;
        return needStr = needStr.substring(0, needLen), right ? str + needStr : needStr + str;
    }), checkType = curry(function(type, x) {
        switch(type){
            case "array":
                return "[object Array]" === Object.prototype.toString.call(x);
            case "object":
                return "[object Object]" === Object.prototype.toString.call(x);
            case "regexp":
                return "[object RegExp]" === Object.prototype.toString.call(x);
            default:
                return typeof x == type;
        }
    }), isObject = checkType("object"), isFunction = checkType("function"), isString = checkType("string"), isNumber = checkType("number"), isBoolean = checkType("boolean"), isArray = checkType("array"), isRegExp = checkType("regexp"), isExist = function(x) {
        return null != x;
    }, isEmpty = function(x) {
        if (!isExist(x)) return !0;
        if (isArray(x) && (x = x.toString()), isString(x)) return 0 === trim(x).length;
        if (isObject(x)) {
            for(var p in x)if (x.hasOwnProperty(p)) return !1;
            return !0;
        }
        return 0 === Math.abs(x - 0);
    }, isNotEmpty = function(x) {
        return !isEmpty(x);
    }, getDocument = curry(function(prop, get) {
        return document.documentElement[prop] || document.body[prop] || 0;
    }), clientWidthBigThen = curry(function(w, get) {
        return getDocument("clientWidth", "") >= w;
    }), isIos = flow(match(/(iPhone|iPod|ios|iPad)/i), isNotEmpty), isAndroid = flow(match(/Android/i), isNotEmpty), isOtherMobile = flow(match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i), isNotEmpty), isMobile = function() {
        var u = navigator.userAgent;
        return isIos(u) ? "ios" : isAndroid(u) ? "android" : !!isOtherMobile(u) && "mobile";
    }, deepCopy = function(sth) {
        var re;
        if (isObject(sth)) for(var key in re = {}, sth)sth.hasOwnProperty(key) && (re[key] = this.deepCopy(sth[key]));
        else re = sth;
        return re;
    }, toArray = function(sth) {
        var re = [];
        if (isObject(sth)) for(var key in sth)sth.hasOwnProperty(key) && (isObject(sth[key]) ? re.push(this.toArray(sth[key])) : re.push(sth[key]));
        else re.push(sth);
        return re;
    }, jsonEncode = function(str) {
        return JSON.stringify(str);
    }, jsonDecode = function(str) {
        var opt;
        try {
            opt = JSON.parse(str);
        } catch (e) {
            opt = null, console.dir(e);
        }
        return opt;
    }, isDate = match(/^\d{4}[-\/][01]\d[-\/][0-3]\d(\s+[0-2]\d(:[0-5]\d(:[0-5]\d)?)?)?/gi), dateDiff = function(f, b, a) {
        if (!(isString(b) && isString(a) && isDate(b) && isDate(a))) return console.dir("date format is wrong"), null;
        if (b = new Date(replace(/\-/g, "/", b)).getTime(), a = new Date(replace(/\-/g, "/", a)).getTime(), isNaN(b) || isNaN(a)) return console.dir("date format is wrong"), null;
        var diff = a - b, div = 1;
        switch(f){
            case "week":
                div = 6048e5;
                break;
            case "day":
                div = 864e5;
                break;
            case "hour":
                div = 36e5;
                break;
            case "minute":
                div = 6e4;
                break;
            case "second":
                div = 1e3;
                break;
            default:
                div = 1;
        }
        return Math.floor(diff / div);
    }, getCookie = function(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        return (arr = document.cookie.match(reg)) ? decodeURIComponent(arr[2]) : "";
    }, setCookie = function(cname, cvalue, exdays, currentPath) {
        isExist(exdays) || (exdays = 1), exdays -= 0, isNaN(exdays) && (exdays = 1), isExist(currentPath) ? path = "" : path = ";path=/";
        var d = new Date;
        d.setTime(d.getTime() + 24 * exdays * 3600000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + encodeURIComponent(cvalue) + "; " + expires + path;
    }, delCookie = function(name) {
        setCookie(name, "", -1);
    }, returnTrue, returnFalse, of, getSingle, Lizus = {
        curry: curry,
        flow: flow,
        of: function(x) {
            return function() {
                return x;
            };
        },
        getSingle: function(fn) {
            var x;
            return function() {
                return x || (x = fn.apply(x, arguments));
            };
        },
        returnFalse: function() {
            return !1;
        },
        returnTrue: function() {
            return !0;
        },
        match: match,
        replace: replace,
        deepCopy: deepCopy,
        toArray: toArray,
        jsonEncode: jsonEncode,
        jsonDecode: jsonDecode,
        lpad: pad(),
        rpad: pad(!0),
        getCookie: getCookie,
        setCookie: setCookie,
        delCookie: delCookie,
        isObject: isObject,
        isString: isString,
        isBoolean: isBoolean,
        isNumber: isNumber,
        isArray: isArray,
        isFunction: isFunction,
        isRegExp: isRegExp,
        isExist: isExist,
        isEmpty: isEmpty,
        isNotEmpty: isNotEmpty,
        dateDiff: dateDiff,
        clientWidthBigThen: clientWidthBigThen,
        getDocument: getDocument
    }, lizus = Object.create(Lizus);
    lizus.trim = trim, lizus.isMobile = isMobile, lizus.sm = clientWidthBigThen(768), lizus.md = clientWidthBigThen(992), lizus.lg = clientWidthBigThen(1200), lizus.st = getDocument("scrollTop"), lizus.ct = getDocument("clientHeight"), lizus.cl = getDocument("clientWidth"), g.orz = lizus;
}(window), function($) {
    orz.isjQuery = function(x) {
        return x instanceof jQuery;
    }, orz.isScrolling = function() {
        return !!$("body").hasClass("scrolling");
    }, orz.startScroll = function(j) {
        $("body").addClass("scrolling"), orz.isjQuery(j) && j.trigger("startScroll");
    }, orz.endScroll = function(j) {
        $("body").removeClass("scrolling"), orz.isjQuery(j) && j.trigger("endScroll");
    };
}(jQuery), function($) {
    orz.scrollTo = function(j, offset, speed) {
        if (!orz.isMobile() && !orz.isScrolling() && orz.isjQuery(j)) {
            var t = j;
            if (!(t.length < 1)) {
                var that = $(this), diff = offset - 0, s = 1e3, st = orz.st(), offset, l = (offset = t.offset()).top;
                isNaN(diff) || (l += diff);
                var len = Math.abs(st - l);
                return (isNaN(speed) || speed <= 0) && (speed = s * len / 4e3), orz.startScroll(that), $("html,body").animate({
                    scrollTop: l
                }, speed, function() {
                    orz.endScroll(that);
                }), !1;
            }
        }
    };
}(jQuery), jQuery(function($) {
    function getID(j) {
        var href = j.attr("data-href");
        href || (href = j.attr("href"));
        var rs = href.split("#"), lh, lhrs = location.href.split("#");
        return rs[0] && rs[0] != lhrs[0] ? "" : rs.pop();
    }
    $("body").on("click", ".auto-scroll", function() {
        if (!orz.isMobile() && !orz.isScrolling()) {
            var target = getID($(this));
            if (target) {
                var t = $("#" + target);
                if (!(t.length < 1)) {
                    var that = $(this), diff = $(this).attr("data-offset") - 0, speed = $(this).attr("data-speed") - 0;
                    return orz.scrollTo(t, diff, speed), !1;
                }
            }
        }
    });
}), function($) {
    var p = $(".part");
    if (!(p.length < 1)) {
        var arr = [];
        part_offset_top(), setTimeout(window_scroll, 0), $(window).on("scroll", window_scroll);
    }
    function part_offset_top() {
        p.each(function() {
            var of = $(this).offset();
            arr.push(Math.floor(of.top));
        });
    }
    function goto_current(index) {
        var a = $("#goto dd"), b = $("#goto dt");
        if (!(a.length < 1)) {
            var h = a.outerHeight();
            a.eq(index).hasClass("current") || (a.removeClass("current"), a.eq(index).addClass("current"), b.animate({
                top: h * index + (a.outerHeight() - b.outerHeight()) / 2 + 1
            }, 50));
        }
    }
    function window_scroll() {
        for(var st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, limit = Math.ceil(st + 20), index = 0, i = 0; i < arr.length && limit >= arr[i]; i++)index = i;
        index < 0 && (index = 0), p.eq(index).hasClass("current") || (p.removeClass("current"), p.eq(index).addClass("current"), goto_current(index));
    }
}(jQuery), function($) {
    var s = $(".sidebar");
    if (!(s.length < 1)) {
        var c = s.children(".content-sidebar");
        if (!(c.length < 1)) {
            var $parent = s.parent();
            if (!($parent.length < 1)) {
                var start = 0, stop = 0, cHeight = 0, dl = $(".content-sidebar dl");
                if (!(dl.length < 1)) {
                    var $part = $(".part");
                    if (!($part.length < 1)) {
                        var arr = [];
                        $part.each(function() {
                            var title = $(this).attr("data-title"), id = $(this).attr("id");
                            title && id && arr.push({
                                title: title,
                                id: id
                            });
                        });
                        var html = "";
                        html += '<dt><span class="show-list"></span></dt>';
                        for(var i = 0; i < arr.length; i++)html += '<dd><a href="#' + arr[i].id + '" class="auto-scroll" data-offset="-20" data-speed=500>' + arr[i].title + "</a></dd>";
                        dl.html(html), init(), check_scroll(), $(window).on("resize", init), $(window).on("scroll", check_scroll), window.onload = function() {
                            init();
                        };
                    }
                }
            }
        }
    }
    function init() {
        var soffset = s.offset();
        start = soffset.top, stop = start + $parent.height(), cinit();
    }
    function cinit() {
        cHeight = c.height();
    }
    function cClear() {
        c.removeClass("fixed"), c.removeClass("absolute");
    }
    function check_scroll() {
        var st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (st <= start && cClear(), st >= stop - cHeight) return c.removeClass("fixed"), void c.addClass("absolute");
        st < stop - cHeight && st > start && (c.removeClass("absolute"), c.addClass("fixed"));
    }
}(jQuery), function($) {
    var $focus = $(".focus");
    if (!($focus.length < 1)) {
        var $a = $focus.children("a");
        $a.length < 1 || ($a.each(function(i) {
            var s = i % 4;
            $(this).css("animation-delay", .1 * s + "s");
        }), setTimeout(ainit, 5e3));
    }
    function ainit() {
        $a.toggleClass("hide"), setTimeout(ainit, 5e3);
    }
}(jQuery), function($) {
    $(".body-home .part .item a").on("click", function() {
        var index = $(".body-home .part .item a").index($(this));
        if (index < 24) {
            var c = "\u5BFC\u822A\u9996\u9875\u70B9\u51FB", a = "\u5E8F\u53F7\uFF1A" + (index + 1), l = $(this).attr("href");
            _hmt.push([
                "_trackEvent",
                c,
                a,
                l
            ]);
        }
    });
}(jQuery), function($) {
    var l = $(".logo");
    if (!(l.length < 1)) {
        var a = l.find(".arrow");
        if (!(a.length < 1)) {
            var b = l.find(".subnav");
            b.length < 1 || (orz.md() && l.find(".arrow").on("mouseenter", function() {
                a.addClass("hover"), b.addClass("show");
            }), l.find(".arrow").on("click", arrow_toggle), l.on("mouseleave", function() {
                a.removeClass("hover"), b.removeClass("show");
            }));
        }
    }
    function arrow_toggle() {
        a.hasClass("hover") ? (a.removeClass("hover"), b.removeClass("show")) : (a.addClass("hover"), b.addClass("show"));
    }
}(jQuery), function($) {
    var m = $(".primary-menus");
    if (!(m.length < 1)) {
        var ul = m.find(".selects");
        if (!(ul.length < 1)) {
            var lis = ul.children("li");
            if (!(lis.length < 1)) {
                var s = m.find(".search"), sVal = s.find(".s").val();
                lis.on("click", function() {
                    var d = $(this).attr("data-target");
                    d && (lis.removeClass("current"), $(this).addClass("current"), s.addClass("hidden"), s.filter("#" + d).removeClass("hidden"), s.filter("#" + d).find(".s").trigger("focusin"));
                }), s.find(".s").on("focusin", function() {
                    $(this).val() == sVal && $(this).val("");
                }), s.find(".s").on("focusout", function() {
                    var v = $(this).val();
                    orz.isEmpty(v) && (v = sVal), s.find(".s").val(v);
                });
            }
        }
    }
}(jQuery), function($) {
    $(".add_fav").on("click", function(e) {
        try {
            if (window.netscape) netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect"), Components.classes["@mozilla.org/preferences-service;1"].getService(Components.interfaces.nsIPrefBranch).setCharPref("browser.startup.homepage", window.location.href), alert("\u6210\u529F\u8BBE\u4E3A\u9996\u9875");
            else {
                if (!window.external) throw "NOT_SUPPORTED";
                document.body.style.behavior = "url(#default#homepage)", document.body.setHomePage(location.href);
            }
        } catch (err) {
            alert("\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u81EA\u52A8\u6536\u85CF\uFF0C\u8BF7\u4F7F\u7528Ctrl+D\u8FDB\u884C\u6536\u85CF");
        }
        e.preventDefault();
    });
}(jQuery), function($) {
    $("input.s").on("focusin", function() {
        $(this).select();
    });
}(jQuery), function($) {
    var a = $(".content-linkto a");
    if (!(a.length < 2)) {
        var rand = Math.floor(Math.random() * a.length);
        a.addClass("hide"), a.eq(rand).removeClass("hide");
    }
}(jQuery), function($) {
    orz.sm() || ($("body").on("click", function() {
        $(".book_item").removeClass("show");
    }), $(".book_item").on("click", function() {
        $(this).addClass("show");
    }));
}(jQuery);

//# sourceMappingURL=CSS.d40b26e2.js.map
